import type { FilterMode } from "./type.ts";

export const activeConfiguration: { mode: FilterMode; activeFilterId?: string; openFilterIds: Set<string> | null } =
  $state({
    mode: "default",
    activeFilterId: undefined,
    openFilterIds: null,
  });

export function setActiveConfiguration(mode: FilterMode, activeFilterId?: string) {
  activeConfiguration.mode = mode;
  activeConfiguration.activeFilterId = activeFilterId;
}

export function setOpenFilterIds(filterIds: string[]) {
  activeConfiguration.openFilterIds = new Set(filterIds);
}

export function toggleFilterAccordion(filterId: string, isOpen: boolean) {
  const next = new Set(activeConfiguration.openFilterIds ?? []);
  if (isOpen) {
    next.add(filterId);
  } else {
    next.delete(filterId);
  }
  activeConfiguration.openFilterIds = next;
}
